import React, { useState, useEffect } from "react";

const getNextTargetTime = (currentTime, hour, minute) => {
    const nextDay = new Date(currentTime);
    nextDay.setDate(nextDay.getDate() + 1);
    nextDay.setHours(hour, minute, 0, 0);
    return nextDay;
};

const Countdown = ({ targetTime }) => {
    const [countdown, setCountdown] = useState({
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {
        const calculateCountdown = () => {
            const currentTime = new Date();

            if (currentTime >= targetTime) {
                setCountdown({ hours: 0, minutes: 0, seconds: 0 });
                return;
            }

            let timeDiff = targetTime.getTime() - currentTime.getTime();
            const hours = Math.floor(timeDiff / (1000 * 60 * 60));
            const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
            const seconds = Math.floor((timeDiff / 1000) % 60);

            setCountdown({ hours, minutes, seconds });
        };

        const timer = setInterval(calculateCountdown, 1000);

        return () => clearInterval(timer);
    }, [targetTime]);

    return (
        <>
            <div className="number">
                <div className="item">{countdown.hours.toString().toLowerCase().padStart(2, "0")}</div>
                <div className="item">:</div>
                <div className="item">{countdown.minutes.toString().toLowerCase().padStart(2, "0")}</div>
                <div className="item">:</div>
                <div className="item">{countdown.seconds.toString().toLowerCase().padStart(2, "0")}</div>
            </div>
        </>
    );
};

const CountDown = ({ date }) => {
    const currentTime = new Date();
    const currentHour = currentTime.getHours();
    const currentMinute = currentTime.getMinutes();

    let targetTime1, targetTime2;
    if (currentHour < 18 || (currentHour === 18 && currentMinute < 10) || (currentHour === 18 && currentMinute > 50) || currentHour > 18) {
        if (currentHour < 18 || (currentHour === 18 && currentMinute < 10)) {
            targetTime1 = new Date();
            targetTime1.setHours(18, 10, 0, 0);
            targetTime2 = new Date();
            targetTime2.setHours(18, 15, 0, 0);
        } else {
            targetTime1 = getNextTargetTime(currentTime, 18, 10);
            targetTime2 = getNextTargetTime(currentTime, 18, 15);
        }
        /*} else if (currentHour == 18 && currentMinute > 10 && currentMinute < 15) {
        targetTime1 = new Date();
        targetTime2 = new Date();
        targetTime2.setHours(18, 15, 0, 0);*/
    } else {
        targetTime1 = new Date();
        targetTime2 = new Date();
    }

    return (
        <>
            <div className="time-box">
                <Countdown targetTime={targetTime1} />
            </div>
        </>
    );
};

export default CountDown;
